<template>
	<div class="split-block-item">
		<div class="split-block-item__left" v-if="fields?.image?.value?.src">
			<PictureImg :fields="fields" class="split-block-item__image" />
		</div>
		<div class="split-block-item__right">
			<div class="split-block-item__header">
				<div v-if="idx" class="split-block-item__index">{{ idx }}</div>
				<div
					v-if="fields?.title?.value"
					class="split-block-item__title"
					v-html="fields.title.value"
				/>
			</div>
			<div class="split-block-item__content">
				<div
					v-if="fields?.description?.value"
					class="split-block-item__description"
					v-html="fields.description.value"
				></div>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
	idx: { type: Number, required: false, default: 0 },
});
</script>

<style lang="scss">
.split-block-item {
	border-top: 1px solid #454545;
	padding-top: var(--spacing-3, 24px);
	margin-bottom: var(--spacing-3, 24px);
	margin-top: var(--spacing-3, 24px);
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	gap: var(--spacing-105, 12px);

	.split-block-item__left {
		width: 100px;
		height: 100px;
		flex-shrink: 0;

		.split-block-item__image {
			width: 100%;
			height: 100%;

			img {
				padding: 0;
				object-fit: cover;
				border-radius: 0;
			}
		}
	}

	.split-block-item__right {
		width: 100%;

		.split-block-item__header {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			gap: var(--spacing-1, 8px);
			margin-bottom: var(--spacing-1, 8px);
		}

		.split-block-item__index {
			display: flex;
			flex-shrink: 0;
			width: 32px;
			height: 32px;
			padding: 10px 0;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 10px;
			border-radius: 100px;
			border: 1px solid #fff2d6;
			color: #fff2d6;
		}

		.split-block-item__title {
			color: var(--color-white, #fff);
			font-family: var(--primary-font, sans-serif);
			font-size: var(--text-base, 16px);
			font-weight: 900;
			line-height: 120%;
			text-transform: uppercase;
		}

		.split-block-item__description {
			color: var(--color-white, #fff);
			font-family: var(--primary-font, sans-serif);
			font-size: var(--text-xs, 12px);
			font-weight: 400;
			line-height: 128%;
		}
	}
}
</style>
